import { useEffect, useRef } from 'react';

const useWaypointAnimation = () => {
  const animatedRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            const effect = el.dataset.animateEffect || 'fadeInUp';
            el.classList.add(effect, 'ftco-animated');
            observer.unobserve(el); // Desconecta o observador após a animação
          }
        });
      },
      {
        root: null, // Padrão é a viewport
        rootMargin: '0px',
        threshold: 0.25, // O elemento é considerado visível quando 25% dele entra na viewport
      }
    );

    animatedRef.current.forEach((el) => {
      if (el) {
        observer.observe(el);
      }
    });

    return () => {
      // Limpa o observador quando o componente é desmontado
      animatedRef.current.forEach((el) => {
        if (el) {
          observer.unobserve(el);
        }
      });
    };
  }, []); // O array vazio garante que o efeito só rode uma vez

  const setAnimatedRef = (el) => {
    if (el) {
      animatedRef.current.push(el);
    }
  };

  return setAnimatedRef;
};

export default useWaypointAnimation;